<template>
  <div class="text-center">
    <span v-for="(network, i) in networks" :key="i" class="mr-4">
      <ShareNetwork
        :network="network"
        :url="baseUrl + '/topic/' + topic.topic_code" 
        :title="topic.topic_name"
        :description="topic.information_text"
      >
        <img :src="require(`../../assets/icons/${network}.png`)" :alt="network" class="mt-2" style="width: 32px; height: 32px">
      </ShareNetwork>
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      height: 500,
      networks: [
        'pinterest',
        'twitter',
        'line',
        'pocket',
        'facebook',
      ],
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  name: 'props',
  props: ['topic'],
}
</script>